import { GameCardData } from '@/features/games/internal/types/game-card-data';
import { GameData } from '@/features/games/shared/types/game-data';
import { GameCategories } from '@/shared/constants/game-categories';

export const gameDataToGameCard = (gameData: GameData): GameCardData => {
  const categories = gameData.categories?.map((category) => ({
    name: category.name,
    path: category.path,
  }));
  const image = {
    src: gameData.defaultImage?.url,
    altText: gameData.defaultImage?.altText,
  };

  return {
    id: gameData.entityId || 0,
    name: gameData.name || '',
    sku: gameData.sku,
    href:
      gameData.path +
        (gameData.categories?.find((c) => c.name === GameCategories.FREE_TO_PLAY) ? 'play' : '') ||
      '',
    image,
    categories,
  } as GameCardData;
};
